import { EmailTemplatesEditForm } from 'application/email-templates/forms';
import { BaseEditViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { EmailTemplatesService } from 'application/email-templates/services';
import { action, observable, runInAction } from 'mobx';
@applicationContext
class EmailTemplatesEditViewStore extends BaseEditViewStore {
    form = new EmailTemplatesEditForm({
        onSubmit: async () => {
            await this.saveTemplate();
        },
    });
    @observable accessor body = null;
    @observable accessor emailName = null;
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new EmailTemplatesService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'email-templates-edit',
            id: id,
            Form: EmailTemplatesEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async (id, opts) => {
                        const response = await service.get(id, opts);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: EmailTemplatesEditForm,
        });

        this.service = service;
    }

    @action
    async initialize() {
        let service = new EmailTemplatesService(this.rootStore.application.baasic.apiClient);
        const prefillData = await service.get(this.id);
        runInAction(() => {
            this.body = prefillData.data.body;
            this.emailName = prefillData.data.name;
        });
        this.rootStore.viewStore.setNavigationOptions({
			title: `${this.emailName}`
		});
    }

    @action
    async saveTemplate() {
        let service = new EmailTemplatesService(this.rootStore.application.baasic.apiClient);
        await service.updateBody(this.id, {id: this.id, body: this.form.$('body').value, name: this.emailName});
        this.rootStore.notificationStore.success('EMAIL_TEMPLATES.EDIT.SUCCESS_UPDATE');
    }

    onCreateError(err) {
        if (!this.errorActions.onCreateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Email Templates already exists.' : err.data.message : `Error occurred while trying to update a Email Templates.`
            );
            return;
        }
        return this.errorActions.onCreateError(err)
    }

    onUpdateError(err) {
        if (!this.errorActions.onUpdateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Email Templates already exists.' : err.data.message : `Error occurred while trying to update a Email Templates.`
            );
            return;
        }
        return this.errorActions.onUpdateError(err);
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('ESIGN_PREFERENCE.CREATE.SUCCESS_CREATE');
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('ESIGN_PREFERENCE.EDIT.SUCCESS_UPDATE', name);
    }
}

export default EmailTemplatesEditViewStore;
